/** MUI Switch styling aligned with site brand colors. */
export const brandSwitchSx = {
  width: 36,
  height: 20,
  p: 0,
  "& .MuiSwitch-switchBase": {
    p: 0.25,
    transition: "transform 0.2s ease",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "var(--brand)",
        opacity: 1,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: 16,
    height: 16,
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.35)",
  },
  "& .MuiSwitch-track": {
    borderRadius: 10,
    backgroundColor: "#3a424d",
    opacity: 1,
  },
};
